<template>
    <div class="rf-view">
        <NavigationBar :title="$t('settings.language.title')">
            <BackButton v-if="canPop" slot="left" @click="pop" />
        </NavigationBar>
        <main>
            <h1>
                {{ $t('settings.language.title') }}
            </h1>

            <List>
                <ListItem v-for="language in languages" :key="language" element-name="label" :selectable="true">
                    {{ getName(language) }}

                    <Radio slot="right" v-model="selectedLanguage" :value="language" name="language" />
                </ListItem>
            </List>
        </main>
    </div>
</template>


<script lang="ts">
import { BackButton, List, ListItem, NavigationBar, Radio } from "@restofrit/components";
import { switchLanguage } from "@restofrit/i18n";
import { Session } from "@restofrit/networking";
import { Customer, CustomerSettings, Language, LanguageHelper } from "@restofrit/structures";
import { Decoder } from "@simonbackx/simple-encoding";
import { NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
    components: {
        NavigationBar,
        List, 
        ListItem,
        Radio,
        BackButton
    },
})
export default class LanguageSelectionView extends Mixins(NavigationMixin) {
    @Prop({ required: true })
    customer: Customer
    
    languages: Language[] = Object.values(Language)

    initialLanguage = this.selectedLanguage

    get selectedLanguage(): Language {
        return this.$i18n.locale.substr(0, 2) as Language
    }

    set selectedLanguage(locale: Language) {
        switchLanguage(locale, false).catch(console.error);
    }

    getName(language: Language) {
        return LanguageHelper.getName(language)
    }

    beforeDestroy() {
        // Save langauge to server
        if (this.initialLanguage !== this.selectedLanguage) {
            Session.shared.authenticatedServer.request({
                method: "PATCH",
                path: "/customers/"+this.customer.id,
                body: { language: this.selectedLanguage },
                decoder: Customer as Decoder<Customer>
            }).then(request => {
                const customer = request.data
                this.customer.set(customer)
            }).catch(() => {
                console.error("Failed to save language")
            })
        }
    }
}
</script>